import React, { useCallback, useEffect, useRef, useState } from "react";
import ThumbnailList from "../../components/ThumbnailList";
import {
  addBatchTag,
  deleteContentByID,
  editVideo,
  exportTranscript,
  search,
} from "../../services/contentServices";
import Footer from "../../components/Footer";
import PageRecords from "../../components/PageRecords";
import Pagination from "../../components/Pagination";
import { locale } from "../../utils/LocaleManager";
import TopAppBar from "../../components/TopAppBar";
import { useContentStore } from "../../stores/contentStore";
import ContextMenu from "../../components/ContextMenu";
import SearchLabel from "../../components/SearchLabel";
import DialogBox from "../../components/DialogBox";
import { Alert, Box, Button, Card, CardContent, Grid, Stack } from "@mui/material";
import { Bounce, toast } from "react-toastify";
import PlayerDialog from "../../components/PlayerDialog";
import { getVideoByID } from "../../services/contentServices";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { handleError } from "../../utils/utilFunctions";
import SideFolderContainer from "../../components/SideFolderContainer";
import { useFolderStore } from "../../stores/folderStore";
import ScreenFolderContainer from "../../components/ScreenFolders";
import LabelText from "../../components/LabelText";
import { black, mainFont } from "../../utils/StyleHelpers";
import Breadcrumb from "../../components/BreadCrumb";
import SearchFilter from "../../components/SearchFilter";
import BoxComponent from "../../components/Box";
import TextFieldInput from "../../components/Textfield";
import { BatchAddTag, EditVideo } from "../../models/editDetails";
import MoveVideo from "../../components/MoveVideo";
import FolderContextMenu from "../../components/FolderContextMenu";
import SkeletonThumbnailLoader from "../../components/SkeletonThumbnailLoader";
import SortFilter from "../../components/SortFilter";
import jsonToCsvExport from "json-to-csv-export";
import { useRolePermissionsStore } from "../../stores/rolePermissionsStore";
import { useVerticalBrowseStore } from "../../stores/verticalBrowseStore";
import { getVerticalContent, listVerticalsForBrowse } from "../../services/verticalBrowseService";
import VideoAssignmentDialog, {
  AssignmentReadbackState,
} from "../../components/VerticalAssignment/VideoAssignmentDialog";
import {
  BulkVerticalAssignmentResponse,
  getCurrentVideoVerticalAssignment,
  updateBulkVideoVerticalAssignments,
  updateVideoVerticalAssignment,
  VerticalAssignmentErrorResponse,
} from "../../services/verticalAssignmentService";

const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_PAGEINDEX = 1;
let errorShowed: any = null;

const MainScreen = () => {
  const rolePermissions = useRolePermissionsStore(
    (state) => state.rolePermissions,
  );
  const {
    setIsLoading,
    isLoading,
    searchKeyword,
    searchKeywordTemp,
    selectedThumbnails,
    setSelectedThumbnails,
    isShowDeleteDialog,
    setIsShowDeleteDialog,
    setIsShowDetails,
    isShowRetagDialog,
    setIsShowRetagDialog,
    setIsShowEdit,
    isShowPlayer,
    videoUrl,
    setVideoUrl,
    setIsShowPlayer,
    filterTypes,
    isShowMoveDialog,
    setIsShowMoveDialog,
    selectedFolders,
    setSelectedFolders,
    sortOrder,
    sortField,
    isShowVerticalAssignmentDialog,
    setIsShowVerticalAssignmentDialog,
  } = useContentStore((state: any) => ({
    setIsLoading: state.setIsLoading,
    isLoading: state.isLoading,
    searchKeyword: state.searchKeyword,
    searchKeywordTemp: state.searchKeywordTemp,
    selectedThumbnails: state.selectedThumbnails,
    setSelectedThumbnails: state.setSelectedThumbnails,
    isShowDeleteDialog: state.isShowDeleteDialog,
    setIsShowDeleteDialog: state.setIsShowDeleteDialog,
    setIsShowDetails: state.setIsShowDetails,
    isShowRetagDialog: state.isShowRetagDialog,
    setIsShowRetagDialog: state.setIsShowRetagDialog,
    setIsShowEdit: state.setIsShowEdit,
    isShowPlayer: state.isShowPlayer,
    videoUrl: state.videoUrl,
    setVideoUrl: state.setVideoUrl,
    setIsShowPlayer: state.setIsShowPlayer,
    filterTypes: state.filterTypes,
    isShowMoveDialog: state.isShowMoveDialog,
    setIsShowMoveDialog: state.setIsShowMoveDialog,
    selectedFolders: state.selectedFolders,
    setSelectedFolders: state.setSelectedFolders,
    sortOrder: state.sortOrder,
    sortField: state.sortField,
    isShowVerticalAssignmentDialog: state.isShowVerticalAssignmentDialog,
    setIsShowVerticalAssignmentDialog: state.setIsShowVerticalAssignmentDialog,
  }));

  const {
    folderId,
    breadcrumbPath,
    isShowFolders,
    deleteRevision,
    isMoveSuccess,
    previousFolderId,
    isShowMoveFolder,
    setSelectedId,
    setIsShowRename,
    setIsShowMoveFolder,
  } = useFolderStore((state: any) => ({
    folderId: state.folderId,
    breadcrumbPath: state.breadcrumbPath,
    isShowFolders: state.isShowFolders,
    deleteRevision: state.deleteRevision,
    isMoveSuccess: state.isMoveSuccess,
    previousFolderId: state.previousFolderId,
    isShowMoveFolder: state.isShowMoveFolder,
    setSelectedId: state.setSelectedId,
    setIsShowRename: state.setIsShowRename,
    setIsShowMoveFolder: state.setIsShowMoveFolder,
  }));

  const browseMode = useVerticalBrowseStore((state: any) => state.mode);
  const selectedVerticalId = useVerticalBrowseStore((state: any) => state.selectedVerticalId);
  const selectedVerticalName = useVerticalBrowseStore((state: any) => state.selectedVerticalName);
  const previousBrowseMode = useRef(browseMode);
  const fetchVerticalDataRequestId = useRef(0);
  const confirmedContentVerticalId = useRef<string | null>(null);
  const browseAvailability = useVerticalBrowseStore((state: any) => state.browseAvailability);
  const contentStatus = useVerticalBrowseStore((state: any) => state.contentStatus);
  const contentError = useVerticalBrowseStore((state: any) => state.contentError);

  const displayBreadcrumb = browseMode === "verticals"
    ? selectedVerticalId
      ? [
          { id: "verticals", text: "Verticals" },
          { id: selectedVerticalId, text: selectedVerticalName || selectedVerticalId }
        ]
      : [{ id: "verticals", text: "Verticals" }]
    : breadcrumbPath.length
      ? breadcrumbPath
      : [{ id: "folders", text: "Folders" }];



  const [searchList, setSearchList] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [pageIndex, setPageIndex] = useState(DEFAULT_PAGEINDEX);
  const [selectedValue, setSelectedValue] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [isShowContext, setIsShowContext] = useState(false);
  const [isShowFolderContext, setIsShowFolderContext] = useState(false);
  const [isShowPlayerScreen, setIsShowPlayerScreen] = useState(false);
  const [isClickedBreadCrumb, setIsClickedBreadCrumb] = useState<any>();
  const [isClickedFolder, setIsClickedFolder] = useState<any>();
  const [isDataEmpty, setIsDataEmpty] = useState(false);
  const [retagValue, setRetagValue] = useState<string>("");
  const [refreshKey, setRefreshKey] = useState(0);
  const [hasLoadedContent, setHasLoadedContent] = useState(false);
  const [verticalUnavailable, setVerticalUnavailable] = useState(false);
  const skeletonItems = Array.from({ length: pageSize });
  const isShowRenameDialog = useContentStore(
    (state: any) => state.isShowRenameDialog,
  );
  const setIsShowRenameDialog = useContentStore(
    (state: any) => state.setIsShowRenameDialog,
  );
  const tempVideoTitle = useContentStore(
    (state: any) => state.tempVideoTitle,
  );
  const setTempVideoTitle = useContentStore(
    (state: any) => state.setTempVideoTitle,
  );

  const navigate = useNavigate();
  const location = useLocation();
  const { verticalId: routeVerticalId } = useParams<{ verticalId?: string }>();

  const [assignmentDialogError, setAssignmentDialogError] =
    useState<VerticalAssignmentErrorResponse | null>(null);
  const [assignmentReadback, setAssignmentReadback] = useState<AssignmentReadbackState>();
  const [assignmentSaving, setAssignmentSaving] = useState(false);

  const assignmentTaxonomyStatus = useVerticalBrowseStore(
    (state: any) => state.taxonomyStatus,
  );
  const assignmentTaxonomyError = useVerticalBrowseStore(
    (state: any) => state.taxonomyError,
  );
  const assignmentTaxonomy = useVerticalBrowseStore((state: any) =>
    state.verticals.map((v: { id: string; name: string }) => ({
      id: v.id,
      name: v.name,
    })),
  );

  const loadAssignmentTaxonomy = useCallback(async () => {
    const store = useVerticalBrowseStore.getState();
    store.setTaxonomyStatus("loading");
    store.setTaxonomyError(null);

    try {
      const result = await listVerticalsForBrowse();
      const currentStore = useVerticalBrowseStore.getState();

      if (result.status === 200) {
        currentStore.setBrowseAvailable(result.data.available);

        if (result.data.available) {
          currentStore.setVerticals(result.data.verticals);
        }

        currentStore.setTaxonomyStatus("loaded");
      } else if (result.status === 401 || result.status === 403) {
        currentStore.setBrowseAvailable(false);
        currentStore.setTaxonomyStatus("error");
        handleError({
          status: result.status,
          toast,
          errorMessage: "",
          onClose: () => {},
        });
      } else {
        currentStore.setTaxonomyStatus("error");
        currentStore.setTaxonomyError("Failed to load verticals.");
      }
    } catch {
      const currentStore = useVerticalBrowseStore.getState();
      currentStore.setTaxonomyStatus("error");
      currentStore.setTaxonomyError("Failed to load verticals.");
    }
  }, []);

  const loadAssignmentReadback = useCallback(
    async (videoIndexId: string) => {
      setAssignmentReadback({ status: "loading" });
      const result = await getCurrentVideoVerticalAssignment(videoIndexId);

      if (result.status === 200 && "verticalIds" in result.data) {
        setAssignmentReadback({
          status: "loaded",
          verticalIds: result.data.verticalIds,
        });
        return;
      }

      if (result.status === 401 || result.status === 403) {
        setIsShowVerticalAssignmentDialog(false);
        setAssignmentSaving(false);
        setAssignmentDialogError(null);
        handleError({ status: result.status, toast });
        return;
      }

      setAssignmentReadback({
        status: "error",
        message: "Failed to load current vertical assignment.",
      });
    },
    [setIsShowVerticalAssignmentDialog],
  );

  useEffect(() => {
    const store = useVerticalBrowseStore.getState();

    if (location.pathname === "/main") {
      if (store.mode !== "folders") store.setMode("folders");
      if (store.selectedVerticalId !== null) store.clearSelectedVertical();
      return;
    }

    if (!location.pathname.startsWith("/main/verticals")) return;

    if (store.mode !== "verticals") store.setMode("verticals");
    if (!routeVerticalId) {
      if (store.selectedVerticalId !== null) store.clearSelectedVertical();
      return;
    }

    if (assignmentTaxonomyStatus === "idle") {
      void loadAssignmentTaxonomy();
      return;
    }
    if (assignmentTaxonomyStatus !== "loaded") return;

    const vertical = assignmentTaxonomy.find((item: { id: string; name: string }) => item.id === routeVerticalId);
    if (!vertical) {
      store.clearSelectedVertical();
      navigate("/main/verticals", { replace: true });
      return;
    }

    if (store.selectedVerticalId !== vertical.id || store.selectedVerticalName !== vertical.name) {
      store.setSelectedVertical(vertical.id, vertical.name);
    }
  }, [
    location.pathname,
    routeVerticalId,
    assignmentTaxonomy,
    assignmentTaxonomyStatus,
    loadAssignmentTaxonomy,
    navigate,
  ]);

  useEffect(() => {
    if (!isShowVerticalAssignmentDialog) return;

    // FE-CAP-01 STAVC-326: revocation must close the dialog and skip loading.
    if (rolePermissions?.video?.retag !== true) {
      closeAssignmentDialog();
      return;
    }

    if (useVerticalBrowseStore.getState().taxonomyStatus === "idle") {
      void loadAssignmentTaxonomy();
    }
    if (selectedThumbnails.length === 1) {
      void loadAssignmentReadback(selectedThumbnails[0].videoIndexId);
    } else {
      setAssignmentReadback(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    isShowVerticalAssignmentDialog,
    rolePermissions?.video?.retag,
    loadAssignmentTaxonomy,
    loadAssignmentReadback,
    selectedThumbnails,
  ]);

  const onAssignmentSubmit = useCallback(
    async (payload: {
      videoIndexIds: string[];
      verticalIds: string[];
    }): Promise<null> => {
      // STAVC-327: runtime revocation must block the bulk PUT and close
      // dialog synchronously, without firing the network call. Read live
      // permissions here so an already-open dialog after Manager retag revoked
      // cannot fire the PUT.
      const liveRolePermissions = useRolePermissionsStore.getState().rolePermissions;
      if (liveRolePermissions?.video?.retag !== true) {
        closeAssignmentDialog();
        return null;
      }

      setAssignmentSaving(true);
      setAssignmentDialogError(null);

      if (payload.videoIndexIds.length === 1) {
        const [videoIndexId] = payload.videoIndexIds;
        const result = await updateVideoVerticalAssignment(
          videoIndexId,
          payload.verticalIds,
          "replace",
        );

        if (result.status === 200) {
          closeAssignmentDialog();
          setSelectedThumbnails([]);
          toast.success("Assigned 1 video", {
            position: "bottom-left",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            pauseOnFocusLoss: false,
            draggable: true,
            progress: undefined,
            theme: "colored",
            transition: Bounce,
          });
          if (browseMode === "verticals" && selectedVerticalId) {
            void fetchVerticalData(selectedVerticalId);
          } else if (browseMode === "folders") {
            fetchFolderData(folderId === 1 ? null : folderId);
          }
          return null;
        }

        if (result.status === 401 || result.status === 403) {
          setAssignmentSaving(false);
          setIsShowVerticalAssignmentDialog(false);
          handleError({ status: result.status, toast });
          return null;
        }

        if (result.status === 400 || result.status === 404) {
          setAssignmentDialogError(result.data as VerticalAssignmentErrorResponse);
          setAssignmentSaving(false);
          return null;
        }

        setAssignmentDialogError({
          error: "invalid_request",
          message: "Assignment could not be completed. Please try again.",
        });
        setAssignmentSaving(false);
        return null;
      }

      const requestedVideoIndexIds = payload.videoIndexIds;

      const result = await updateBulkVideoVerticalAssignments(payload.videoIndexIds, payload.verticalIds);

      if (result.status === 200) {
        if (!("videoIndexIds" in result.data) || !("verticalIds" in result.data)) {
          setAssignmentDialogError({
            error: "invalid_request",
            message: "Assignment response was malformed.",
          });
          setAssignmentSaving(false);
          return null;
        }

        const response = result.data as BulkVerticalAssignmentResponse;
        const sameIds =
          response.videoIndexIds.length === requestedVideoIndexIds.length &&
          response.videoIndexIds.every((id) => requestedVideoIndexIds.includes(id));
        const sameVerticalIds =
          response.verticalIds.length === payload.verticalIds.length &&
          response.verticalIds.every((id) => payload.verticalIds.includes(id));
        if (!sameIds || !sameVerticalIds) {
          setAssignmentDialogError({
            error: "invalid_request",
            message: "Assignment response did not match the requested videos and verticals.",
          });
          setAssignmentSaving(false);
          return null;
        }

        setAssignmentSaving(false);
        setIsShowVerticalAssignmentDialog(false);
        setSelectedThumbnails([]);
        toast.success(`Assigned ${response.videoIndexIds.length} video${response.videoIndexIds.length === 1 ? "" : "s"}`, {
          position: "bottom-left",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          pauseOnFocusLoss: false,
          draggable: true,
          progress: undefined,
          theme: "colored",
          transition: Bounce,
        });

        if (browseMode === "verticals" && selectedVerticalId) {
          void fetchVerticalData(selectedVerticalId);
        } else if (browseMode === "folders") {
          fetchFolderData(folderId === 1 ? null : folderId);
        }
        return null;
      }

      if (result.status === 400 || result.status === 404 || result.status === 403) {
        if (!("error" in result.data)) {
          setAssignmentDialogError({
            error: "invalid_request",
            message: "Assignment error response was malformed.",
          });
          setAssignmentSaving(false);
          return null;
        }
        const err = result.data as VerticalAssignmentErrorResponse;
        setAssignmentDialogError(err);
        if (result.status === 404) {
          setAssignmentSaving(false);
          setIsShowVerticalAssignmentDialog(false);
          setSelectedThumbnails([]);
          if (browseMode === "verticals" && selectedVerticalId) {
            void fetchVerticalData(selectedVerticalId);
          } else if (browseMode === "folders") {
            fetchFolderData(folderId === 1 ? null : folderId);
          }
          return null;
        }
        if (result.status === 403) {
          // FE-DENY-01 STAVC-326: 403 is a denial, not an auth failure.
          setAssignmentSaving(false);
          setIsShowVerticalAssignmentDialog(false);
          toast.error(err.message || "You do not have access to assign these videos.");
          return null;
        }
        setAssignmentSaving(false);
        return null;
      }

      if (result.status === 401) {
        setAssignmentSaving(false);
        setIsShowVerticalAssignmentDialog(false);
        handleError({
          status: 401,
          toast,
          errorMessage: "",
          onClose: () => {},
        });
        return null;
      }

      setAssignmentDialogError({
        error: "invalid_request",
        message: "Assignment could not be completed. Please try again.",
      });
      setAssignmentSaving(false);
      return null;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [browseMode, selectedVerticalId, folderId, rolePermissions],
  );

  const closeAssignmentDialog = useCallback(() => {
    setIsShowVerticalAssignmentDialog(false);
    setAssignmentSaving(false);
    setAssignmentDialogError(null);
    setAssignmentReadback(undefined);
  }, [setIsShowVerticalAssignmentDialog]);

  const clearSelectedContent = () => {
    setSelectedThumbnails([]);
    setIsShowDeleteDialog(false);
    setIsShowRetagDialog(false);
    setIsShowRenameDialog(false);
    setIsShowMoveDialog(false);
    setIsShowPlayer(false);
    setIsShowPlayerScreen(false);
    setVideoUrl("");
  };

  const fetchVerticalData = async (
    verticalId: string,
    requestedPageIndex = pageIndex,
    requestedPageSize = pageSize,
    requestedSortOrder = sortOrder,
    requestedSortField = sortField,
  ) => {
    const thisRequestId = ++fetchVerticalDataRequestId.current;

    setIsLoading(true);
    const allowedVerticalSortFields = new Set(["", "title", "created", "datemodified", "status"]);
    let sanitizedSortField = requestedSortField || "";
    if (sanitizedSortField === "datecreated") {
      sanitizedSortField = "created";
    } else if (!allowedVerticalSortFields.has(sanitizedSortField)) {
      sanitizedSortField = "";
    }

    useVerticalBrowseStore.getState().setContentStatus("loading");

    const contentData = await getVerticalContent(
      verticalId,
      requestedPageIndex,
      requestedPageSize,
      requestedSortOrder,
      sanitizedSortField,
    );

    // Guard: ignore the response if a newer same-vertical request superseded it,
    // OR the user has switched to a different vertical since this call started.
    if (fetchVerticalDataRequestId.current !== thisRequestId) {
      return;
    }
    const currentSelectedVerticalId = useVerticalBrowseStore.getState().selectedVerticalId;
    if (currentSelectedVerticalId !== verticalId) {
      return;
    }

    if (contentData.status === 200) {
      const data = contentData.data;
      if (data?.items?.length === 0) {
        setIsDataEmpty(true);
      } else {
        setIsDataEmpty(false);
      }
      setSearchList(data.items);
      setTotalRecords(data.totalCount);
      setTotalPages(data.totalPages);
      setPageIndex(data.pageIndex);
      setPageSize(data.pageSize);
      setHasLoadedContent(true);
      confirmedContentVerticalId.current = verticalId;
      setVerticalUnavailable(false);
      useVerticalBrowseStore.getState().setContentStatus("idle");
      useVerticalBrowseStore.getState().setContentError(null);
    } else if (contentData.status === 401) {
      setSearchList([]);
      setTotalRecords(0);
      setTotalPages(0);
      setIsDataEmpty(true);
      clearSelectedContent();
      setHasLoadedContent(false);
      setVerticalUnavailable(false);
      useVerticalBrowseStore.getState().setContentStatus("error");
      useVerticalBrowseStore.getState().setContentError("Authentication required");
      handleError({
        status: 401,
        toast,
        errorMessage: `Error: Encountered an error fetching vertical content.`,
        onClose: () => { },
      });
    } else if (contentData.status === 403) {
      setSearchList([]);
      setTotalRecords(0);
      setTotalPages(0);
      setIsDataEmpty(true);
      setSelectedThumbnails([]);
      setHasLoadedContent(false);
      setVerticalUnavailable(false);
      useVerticalBrowseStore.getState().setContentStatus("error");
      useVerticalBrowseStore.getState().setContentError("Access denied");

      const { setBrowseAvailable, clearSelectedVertical } = useVerticalBrowseStore.getState();
      clearSelectedVertical();
      setBrowseAvailable(false);

      handleError({
        status: 403,
        toast,
        errorMessage: `Error: Encountered an error fetching vertical content.`,
        onClose: () => { },
      });
    } else {
      const status = contentData.status || 500;

      if (status === 404) {
        setSearchList([]);
        setTotalRecords(0);
        setTotalPages(0);
        setIsDataEmpty(true);
        setSelectedThumbnails([]);
        setHasLoadedContent(false);
        setVerticalUnavailable(true);
        useVerticalBrowseStore.getState().setContentStatus("idle");
        useVerticalBrowseStore.getState().setContentError(null);
        useVerticalBrowseStore.getState().clearSelectedVertical();

        const store = useVerticalBrowseStore.getState();
        store.setTaxonomyStatus("loading");
        store.setTaxonomyError(null);
        try {
          const result = await listVerticalsForBrowse();
          if (result.status === 200) {
            if (result.data.available === false) {
              store.setBrowseAvailable(false);
              return;
            }
            store.setVerticals(result.data.verticals);
            store.setTaxonomyStatus("loaded");
          } else if (result.status === 401) {
            store.setBrowseAvailable(false);
            store.setTaxonomyError("Authentication required");
            store.setTaxonomyStatus("error");
            handleError({
              status: 401,
              toast,
              errorMessage: "",
              onClose: () => {},
            });
          } else if (result.status === 403) {
            store.setBrowseAvailable(false);
            store.setTaxonomyError("Access denied");
            store.setTaxonomyStatus("error");
            handleError({
              status: 403,
              toast,
              errorMessage: "",
              onClose: () => {},
            });
          } else {
            store.setTaxonomyError("Failed to load verticals.");
            store.setTaxonomyStatus("error");
          }
        } catch {
          store.setTaxonomyError("Failed to load verticals.");
          store.setTaxonomyStatus("error");
        }
      } else {
        const errorMessage = `Failed to load content (HTTP ${status})`;
        useVerticalBrowseStore.getState().setContentStatus("error");
        useVerticalBrowseStore.getState().setContentError(errorMessage);

        // Only preserve confirmed content if this is a refresh of the same vertical that owns it
        if (!hasLoadedContent || confirmedContentVerticalId.current !== verticalId) {
          setSearchList([]);
          setTotalRecords(0);
          setTotalPages(0);
          setIsDataEmpty(true);
        }
      }
    }
    setIsLoading(false);
  };

  const handleRetry = () => {
    if (selectedVerticalId) {
      void fetchVerticalData(selectedVerticalId, pageIndex, pageSize, sortOrder, sortField);
    }
  };

  const searchFolderId = folderId === 1 ? null : folderId;

  const fetchData = async (
    pageSize: any,
    pageIndex: any,
    sortOrder: any,
    searchKeyword: any,
    filterTypes: any,
    folderId: any,
    sortField: any,
  ) => {
    const id = folderId === 1 ? null : folderId;

    const searchData = await search(
      pageSize,
      pageIndex,
      sortOrder,
      searchKeyword,
      filterTypes,
      id,
      sortField,
    );
    if (useVerticalBrowseStore.getState().mode !== "folders") return;

    if (searchData.status === 200) {
      const data = searchData.data;
      if (data?.items?.length === 0) {
        setIsDataEmpty(true);
      } else {
        setIsDataEmpty(false);
      }
      setSearchList(data.items);
      setTotalRecords(data.totalCount);
      setTotalPages(data.totalPages);
      setPageIndex(data.pageIndex);
      setPageSize(data.pageSize);
    } else {
      handleError({
        status: searchData.response.status,
        toast,
        errorMessage: `Error: Encountered an error fetching list of video. (CODE: ${searchData.code})`,
        onClose: () => { },
      });
    }
    setIsLoading(false);
  };

  const onClickPlay = async () => {
    const [selected] = selectedThumbnails;
    const getUrl = await getVideoByID(selected.videoIndexId);
    if (getUrl.status === 200) {
      const data = getUrl.data;
      setVideoUrl(data);
      setIsShowPlayer(true);
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: getUrl.response.status,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => (errorShowed = null),
      });
    }
  };

  const onChangePageSize = (event: { target: { value: any } }) => {
    setIsLoading(true);
    setSelectedValue(event.target.value);
    setPageSize(event.target.value);
    setSelectedThumbnails([]);
    setPageIndex(DEFAULT_PAGEINDEX);
  };

  const onChangePageRow = (_event: any, value: number) => {
    setPageIndex(value);
    setIsLoading(true);
    setSelectedThumbnails([]);
    if (browseMode === "verticals" && selectedVerticalId) {
      void fetchVerticalData(selectedVerticalId, value);
      return;
    }
    fetchData(
      pageSize,
      value,
      sortOrder,
      searchKeyword,
      filterTypes,
      folderId,
      sortField,
    );
  };

  const onChangePageIndex = (value: number) => {
    if (totalPages >= value) {
      setIsLoading(true);
      setPageIndex(value);
      setSelectedThumbnails([]);
      if (browseMode === "verticals" && selectedVerticalId) {
        void fetchVerticalData(selectedVerticalId, value);
        return;
      }
      fetchData(
        pageSize,
        value,
        sortOrder,
        searchKeyword,
        filterTypes,
        folderId,
        sortField,
      );
    }
  };

  const isShowFooter = () => totalRecords > DEFAULT_PAGE_SIZE;

  const onClose = () => {
    setIsShowPlayer(false);
    setIsShowPlayerScreen(false);
  };

  const onClickDetails = async () => {
    setIsLoading(true);
    toast.info("Redirecting to details page...", {
      position: "bottom-left",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: false,
      pauseOnFocusLoss: false,
      theme: "colored",
      closeButton: false,
    });
    const [selected] = selectedThumbnails;
    const getUrl = await getVideoByID(selected.videoIndexId);
    if (getUrl.status === 200) {
      const data = getUrl.data;
      setVideoUrl(data);
      setIsShowPlayer(true);
      navigate(
        "/details/" +
        selected.videoIndexId +
        (searchKeyword ? "/" + searchKeyword : ""),
      );
      setIsShowDetails(true);
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: getUrl.response.status,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => (errorShowed = null),
      });
    }
  };

  const onClickEdit = async () => {
    const [selected] = selectedThumbnails;
    const getUrl = await getVideoByID(selected.videoIndexId);
    if (getUrl.status === 200) {
      const data = getUrl.data;
      setVideoUrl(data);
      navigate("/edit/" + selected.videoIndexId);
      setIsShowEdit(true);
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: getUrl.response.status,
        toast,
        errorMessage: "Error: Video might be deleted or not available.",
        onClose: () => (errorShowed = null),
      });
    }
  };

  const onUnassignVertical = async () => {
    if (browseMode !== "verticals" || !selectedVerticalId) return;

    if (
      useRolePermissionsStore.getState().rolePermissions?.video?.retag !== true
    ) {
      return;
    }

    const responses = await Promise.all(
      selectedThumbnails.map((thumbnail: any) =>
        updateVideoVerticalAssignment(
          thumbnail.videoIndexId,
          [selectedVerticalId],
          "remove",
        ),
      ),
    );
    const allSucceeded = responses.every((response) => response.status === 200);

    if (allSucceeded) {
      setSelectedThumbnails([]);
      toast.success(
        `Unassigned ${selectedThumbnails.length} video${
          selectedThumbnails.length === 1 ? "" : "s"
        } from vertical`,
      );
    } else {
      toast.error("Unable to unassign all selected videos from vertical.");
    }

    void fetchVerticalData(
      selectedVerticalId,
      pageIndex,
      pageSize,
      sortOrder,
      sortField,
    );
  };

  const renderDeleteDialog = () => (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={1}>
        {selectedThumbnails.map((thumbnail: any) => (
          <Card key={thumbnail.id} variant="outlined">
            <CardContent sx={{ padding: "1.25rem" }}>
              <Stack direction="row" gap="0.625rem">
                <img
                  src={thumbnail.image}
                  alt={thumbnail.name}
                  style={{
                    height: "auto",
                    width: "2.5rem",
                    borderRadius: "0.25rem",
                    alignSelf: "stretch",
                  }}
                />
                {thumbnail.name}
              </Stack>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Box>
  );

  const deleteVideos = async () => {
    if (!rolePermissions?.video?.delete) return;
    if (browseMode !== "folders" && browseMode !== "verticals") return;

    setIsShowDeleteDialog(false);
    toast.warning(`Processing: Deleting ${selectedThumbnails.length} video/s`, {
      position: "bottom-left",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });

    const deleted = await Promise.allSettled(
      selectedThumbnails.map((thumbnail: any) =>
        deleteContentByID(thumbnail.videoIndexId),
      ),
    );
    const deleteResult = deleted.filter(
      (result) => result.status === "rejected",
    );
    // No rejection on delete
    if (deleteResult?.length === 0) {
      setSelectedThumbnails([]);
      toast.success("Video Deleted", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      onClose();
      setIsLoading(true);
      if (browseMode === "verticals" && selectedVerticalId) {
        void fetchVerticalData(
          selectedVerticalId,
          pageIndex,
          pageSize,
          sortOrder,
          sortField,
        );
      } else {
        fetchData(
          pageSize,
          pageIndex,
          sortOrder,
          searchKeyword,
          filterTypes,
          folderId,
          sortField,
        );
      }
      // some deletion failed
    } else {
      setSelectedThumbnails([]);
      toast.error("Error: Encountered an error while deleting video.", {
        position: "bottom-left",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  const onCopyLinks = async () => {
    toast.warning(`Processing: Copying link`, {
      position: "bottom-left",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      draggable: true,
      pauseOnFocusLoss: false,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });

    const [thumbnail] = selectedThumbnails;
    const copied = await getVideoByID(thumbnail.videoIndexId);

    if (copied.status === 200) {
      navigator.clipboard.writeText(copied.data);
      toast.success("Video Link Copied", {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
    } else {
      handleError({
        status: copied.response.status,
        toast,
        errorMessage: "Error: Encountered an error while copying link.",
        onClose: () => { },
      });
    }
  };

  const onPlayerError = (e: any) => {
    if (errorShowed !== null || e.code === 7000) return;
    errorShowed = toast.error(
      "Error: Video might be deleted or not available",
      {
        position: "bottom-left",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        draggable: true,
        pauseOnFocusLoss: false,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => (errorShowed = null),
      },
    );
  };

  const onDownload = () => {
    let toastProcessing = toast.warning(
      "Processing: Generating Download links...",
      {
        position: "bottom-left",
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        autoClose: false,
        theme: "colored",
        transition: Bounce,
      },
    );

    Promise.allSettled(
      selectedThumbnails.map(async (selected: any) => {
        const getUrl = await getVideoByID(selected.videoIndexId);
        if (getUrl.status === 200) {
          const data = getUrl.data;

          await fetch(data, {
            headers: new Headers({
              Origin: window.location.origin,
            }),
            mode: "cors",
          })
            .then((response) => response.blob())
            .then((blob) => {
              let blobUrl = window.URL.createObjectURL(blob);
              var link = document.createElement("a");
              link.href = blobUrl;
              link.download = selected.name;
              link.click();

              toast.success(
                `Success: Download link generated for: ${selected.name}`,
                {
                  position: "bottom-left",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: false,
                  pauseOnFocusLoss: false,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  transition: Bounce,
                },
              );
            })
            .catch((e) => {
              toast.error(
                `Error: Encountered issue downloading: ${selected.name}`,
                {
                  position: "bottom-left",
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: false,
                  pauseOnFocusLoss: false,
                  draggable: true,
                  progress: undefined,
                  theme: "colored",
                  transition: Bounce,
                },
              );
            });
        } else {
          handleError({
            status: getUrl.response.status,
            toast,
            errorMessage: "Error: Video might be deleted or not available",
            onClose: () => { },
          });
        }
      }),
    ).then(() => toast.dismiss(toastProcessing));
  };

  const renderRetagDialog = () => {
    return (
      <TextFieldInput
        value={retagValue}
        onChange={(e: any) => setRetagValue(e.target.value)}
        autoFocus={true}
      />
    );
  };

  const onRetag = async () => {
    if (!rolePermissions?.video?.retag) return;
    if (browseMode !== "folders" && browseMode !== "verticals") return;

    setIsLoading(true);
    setIsShowRetagDialog(false);
    const requestBody: BatchAddTag = {
      videoIndexIds: selectedThumbnails.map((thumb: any) => thumb.videoIndexId),
      tag: retagValue,
    };
    const batchTagResponse = await addBatchTag(requestBody);
    const selectedCount = selectedThumbnails.length;
    const message =
      selectedCount > 1
        ? locale.success_retag_multiple.replace("%d", selectedCount)
        : locale.success_retag;
    setIsLoading(false);
    setRetagValue("");
    if (batchTagResponse.status === 200) {
      setSelectedThumbnails([]);
      toast.success(message, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
      });
      setIsLoading(true);
      if (browseMode === "verticals" && selectedVerticalId) {
        void fetchVerticalData(
          selectedVerticalId,
          pageIndex,
          pageSize,
          sortOrder,
          sortField,
        );
      } else {
        fetchData(
          pageSize,
          pageIndex,
          sortOrder,
          searchKeyword,
          filterTypes,
          folderId,
          sortField,
        );
      }
    } else {
      setSelectedThumbnails([]);
      handleError({
        status: batchTagResponse.response.status,
        toast,
        errorMessage: `Error: Encountered an error batch tagging. (CODE: ${batchTagResponse.code})`,
        onClose: () => { },
      });
    }
  };

  const fetchFolderData = async (id: any) => {
    await fetchData(
      pageSize,
      pageIndex,
      sortOrder,
      searchKeyword,
      filterTypes,
      id,
      sortField,
    );
  };

  const onRenameFolder = () => {
    const [folder] = selectedFolders;
    setSelectedId(folder.id);
    setIsShowRename(true);
  };

  const onRenameVideo = () => {
    setTempVideoTitle(selectedThumbnails[0].name);
    setIsShowRenameDialog(true);
  };

  const editVideoService = async (
    editVideoRequest: EditVideo,
    successMessage: string,
  ) => {
    const requestEditVideo = await editVideo(editVideoRequest);

    if (requestEditVideo.status === 200) {
      setSelectedThumbnails([]);
      setRefreshKey((prev) => prev + 1);
      toast.success(successMessage, {
        position: "bottom-left",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
        transition: Bounce,
        onClose: () => { },
      });
    } else {
      handleError({
        status: requestEditVideo.response.status,
        toast,
        errorMessage: `Error: Encountered an error. (CODE: ${requestEditVideo.code})`,
        onClose: () => { },
      });
    }
  };

  const onSubmitRename = async () => {
    if (!rolePermissions?.video?.rename) return;
    if (browseMode !== "folders" && browseMode !== "verticals") return;

    const editVideoRequest: EditVideo = {
      videoIndexId: selectedThumbnails[0].videoIndexId,
      name: tempVideoTitle,
      description: tempVideoTitle,
      newTags: [],
      editTags: [],
      deleteTags: [],
    };

    setIsShowRenameDialog(false);
    toast.warn(locale.cannot_cancel_saving, {
      position: "bottom-left",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      pauseOnFocusLoss: false,
      draggable: true,
      progress: undefined,
      theme: "colored",
      transition: Bounce,
    });
    await editVideoService(editVideoRequest, locale.rename_video_success);
  };

  useEffect(() => {
    if (!pageIndex) return;

    if (searchKeyword) setSearchList([]);

    if (browseMode === "verticals") {
      if (selectedVerticalId) {
        void fetchVerticalData(
          selectedVerticalId,
          DEFAULT_PAGEINDEX,
          pageSize,
          sortOrder,
          sortField,
        );
      }
      return;
    }

    fetchData(
      pageSize,
      DEFAULT_PAGEINDEX,
      sortOrder,
      searchKeyword,
      filterTypes,
      searchFolderId,
      sortField,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageSize, searchKeyword, filterTypes, sortOrder, sortField, refreshKey, browseMode, selectedVerticalId]);

  // Clear confirmed content and close all A-owned surfaces when switching to a different vertical
  useEffect(() => {
    if (browseMode !== "verticals" || !selectedVerticalId) return;

    // If switching to a different vertical, clear the confirmed content
    if (confirmedContentVerticalId.current !== selectedVerticalId) {
      setSearchList([]);
      setTotalRecords(0);
      setTotalPages(0);
      setPageIndex(DEFAULT_PAGEINDEX);
      setIsDataEmpty(false);
      setHasLoadedContent(false);
      setVerticalUnavailable(false);
      clearSelectedContent();

      // Update ownership to new vertical
      confirmedContentVerticalId.current = selectedVerticalId;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [browseMode, selectedVerticalId]);

  useEffect(() => {
    if (selectedThumbnails.length) {
      setSelectedFolders([]);
    }

    setIsShowContext(selectedThumbnails.length > 0);
  }, [selectedThumbnails, setSelectedFolders]);

  useEffect(() => {
    if (selectedFolders.length) {
      setSelectedThumbnails([]);
    }

    setIsShowFolderContext(selectedFolders.length > 0);
  }, [selectedFolders, setSelectedThumbnails]);

  useEffect(() => {
    if (isShowPlayer) {
      setIsShowPlayerScreen(true);
    }
  }, [isShowPlayer, videoUrl]);

  useEffect(() => {
    //Get videos in folder
    if (
      browseMode === "folders" &&
      !isShowMoveDialog &&
      !isShowMoveFolder &&
      folderId !== null
    ) {
      fetchFolderData(searchFolderId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [folderId, browseMode]);

  useEffect(() => {
    const modeChanged = previousBrowseMode.current !== browseMode;
    previousBrowseMode.current = browseMode;

    if (modeChanged) {
      setSearchList([]);
      setTotalRecords(0);
      setTotalPages(0);
      setPageIndex(DEFAULT_PAGEINDEX);
      setIsDataEmpty(false);
      clearSelectedContent();
      setVerticalUnavailable(false);
      setIsLoading(false);

      if (browseMode === "folders") {
        fetchFolderData(searchFolderId);
        return;
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [browseMode, selectedVerticalId]);

  useEffect(() => {
    //Delete & Move
    if (deleteRevision <= 0 && !isMoveSuccess) {
      return;
    }

    if (browseMode === "verticals" && selectedVerticalId) {
      void fetchVerticalData(selectedVerticalId, pageIndex);
      return;
    }

    fetchFolderData(deleteRevision > 0 ? folderId : previousFolderId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteRevision, isMoveSuccess]);

  useEffect(() => {
    if (browseAvailability !== "pending") {
      return;
    }

    let cancelled = false;

    listVerticalsForBrowse()
      .then((result) => {
        if (cancelled) return;
        if (result.status === 200) {
          useVerticalBrowseStore.getState().setBrowseAvailable(result.data.available);
        } else if (result.status === 401) {
          useVerticalBrowseStore.getState().setBrowseAvailable(false);
          handleError({
            status: 401,
            toast,
            errorMessage: "",
            onClose: () => {},
          });
        } else if (result.status === 403) {
          useVerticalBrowseStore.getState().setBrowseAvailable(false);
          handleError({
            status: 403,
            toast,
            errorMessage: "",
            onClose: () => {},
          });
        } else {
          useVerticalBrowseStore.getState().setBrowseAvailabilityError();
        }
      })
      .catch(() => {
        if (cancelled) return;
        useVerticalBrowseStore.getState().setBrowseAvailabilityError();
      });

    return () => {
      cancelled = true;
    };
  }, [browseAvailability]);

  return (
    <>
      {isShowPlayerScreen ? (
        <PlayerDialog
          isBrowseOnly={false}
          url={videoUrl}
          onClose={() => onClose()}
          name={selectedThumbnails[0]?.name}
          onPlayerError={onPlayerError}
          onCopyLinks={() => onCopyLinks()}
          onDownload={() => onDownload()}
          onClickDetails={() => onClickDetails()}
          onClickEdit={() => onClickEdit()}
          onClickRename={() => onRenameVideo()}
        />
      ) : (
        <></>
      )}
      <TopAppBar
        nav={"main"}
        handleLogout={() => { }}
        setPageIndex={pageIndex}
      ></TopAppBar>

      <SideFolderContainer
        isClickedBreadCrumb={isClickedBreadCrumb}
        setIsClickedBreadCrumb={setIsClickedBreadCrumb}
        isClickedFolder={isClickedFolder}
        setIsClickedFolder={setIsClickedFolder}
        verticalBrowseAvailable={browseAvailability === "allowed"}
        onBrowseNavigate={(path) => navigate(path)}
      />
      <div
        style={{
          paddingLeft: "419px",
          paddingRight: "30px",
          height: "80vh",
          paddingTop: "148px",
          overflowY: "hidden",
        }}
      >
        <>
          {searchKeywordTemp.length > 1 && browseMode !== "verticals" ? (

            <Grid item xs={12}>
              <SearchLabel />
              <Box display="flex">
                <SearchFilter label={locale.search_filter} />
                <SortFilter />
              </Box>
              {!isShowFolderContext && isShowContext && (
                <ContextMenu
                  isShow={isShowContext}
                  onClickPlay={() => onClickPlay()}
                  onDownload={() => onDownload()}
                  onClickDetails={() => onClickDetails()}
                  onCopyLinks={() => onCopyLinks()}
                  onClickEdit={() => onClickEdit()}
                  onClickRetag={() => setIsShowRetagDialog(true)}
                  onClickMove={() => setIsShowMoveDialog(true)}
                  onUnassignVertical={
                    browseMode === "verticals" && selectedVerticalId
                      ? onUnassignVertical
                      : undefined
                  }
                  onClickRename={() => onRenameVideo()}
                  onClickExport={() => {
                    (async () => {
                      const transcripts = await exportTranscript(
                        selectedThumbnails[0].videoIndexId,
                      );

                      if (!transcripts?.data || transcripts.data.length === 0) {
                        toast.error(
                          locale.transcript_export_error,
                          {
                            position: "bottom-left",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: false,
                            pauseOnFocusLoss: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          },
                        );
                        return;
                      }

                      jsonToCsvExport({
                        data: transcripts.data,
                        filename: `${selectedThumbnails[0].name}.csv`,
                      });
                    })();
                  }}
                />
              )}
              {browseMode !== "verticals" && !isShowContext && isShowFolderContext && (
                <FolderContextMenu
                  isShow={isShowFolderContext}
                  onRename={() => onRenameFolder()}
                  onMove={() => setIsShowMoveFolder(true)}
                />
              )}
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Breadcrumb
                path={displayBreadcrumb}
                onClick={(e: any) => setIsClickedBreadCrumb(e)}
              />
              {!isShowFolderContext && isShowContext && (
                <ContextMenu
                  isShow={isShowContext}
                  onClickPlay={() => onClickPlay()}
                  onDownload={() => onDownload()}
                  onClickDetails={() => onClickDetails()}
                  onCopyLinks={() => onCopyLinks()}
                  onClickEdit={() => onClickEdit()}
                  onClickRetag={() => setIsShowRetagDialog(true)}
                  onClickMove={() => setIsShowMoveDialog(true)}
                  onUnassignVertical={
                    browseMode === "verticals" && selectedVerticalId
                      ? onUnassignVertical
                      : undefined
                  }
                  onClickRename={() => onRenameVideo()}
                  onClickExport={() => {
                    (async () => {
                      const transcripts = await exportTranscript(
                        selectedThumbnails[0].videoIndexId,
                      );

                      if (!transcripts?.data || transcripts.data.length === 0) {
                        toast.error(
                          locale.transcript_export_error,
                          {
                            position: "bottom-left",
                            autoClose: 2000,
                            hideProgressBar: false,
                            closeOnClick: false,
                            pauseOnHover: false,
                            pauseOnFocusLoss: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                          },
                        );
                        return;
                      }

                      jsonToCsvExport({
                        data: transcripts.data,
                        filename: `${selectedThumbnails[0].name}.csv`,
                      });
                    })();
                  }}
                />
              )}
              {browseMode !== "verticals" && !isShowContext && isShowFolderContext && (
                <FolderContextMenu
                  isShow={isShowFolderContext}
                  onRename={() => onRenameFolder()}
                  onMove={() => setIsShowMoveFolder(true)}
                />
              )}
            </Grid>
          )}
          <div
            aria-busy={browseMode === "verticals" && isLoading}
            aria-live="polite"
            style={{ height: "calc(100vh - 300px)", overflowY: "scroll", paddingBottom: "100px" }}
          >
            {browseMode === "verticals" && selectedVerticalName && (
              <div role="status" className="sr-only" style={{ position: "absolute", left: "-9999px" }}>
                {isLoading
                  ? `${selectedVerticalName} loading`
                  : `${selectedVerticalName} ready`}
              </div>
            )}
            {verticalUnavailable && (
              <div role="status" className="sr-only" style={{ position: "absolute", left: "-9999px" }}>
                This vertical is no longer available.
              </div>
            )}
            {browseMode !== "verticals" && isShowFolders && (
              <ScreenFolderContainer
                isClickedFolder={isClickedFolder}
                setIsClickedFolder={setIsClickedFolder}
              />
            )}
            {browseMode === "verticals" && contentStatus === "error" && (
              <Alert
                severity="error"
                role="alert"
                sx={{ mb: 2 }}
                action={
                  <Button color="inherit" size="small" onClick={handleRetry}>
                    Retry
                  </Button>
                }
              >
                {contentError}
              </Alert>
            )}
            {browseMode === "verticals" && !selectedVerticalId ? (
              <LabelText
                text="Select a vertical to view videos."
                style={{
                  fontFamily: mainFont,
                  fontSize: "1rem",
                  color: black,
                }}
              />
            ) : !isDataEmpty ? (
              <>
                <LabelText
                  text={locale.videos}
                  style={{
                    fontFamily: mainFont,
                    fontWeight: 600,
                    fontSize: "1.25rem",
                    lineHeight: "1.5rem",
                    color: black,
                  }}
                />

                {searchList.length > 0 ? (
                  <ThumbnailList
                    key={refreshKey}
                    items={searchList}
                    onClickPlay={onClickPlay}
                    onDownload={onDownload}
                    onClickDetails={onClickDetails}
                    isBrowseOnly={browseMode === "verticals"}
                    onCopyLinks={onCopyLinks}
                    onClickEdit={onClickEdit}
                    onClickRetag={() => setIsShowRetagDialog(true)}
                    onClickMove={() => setIsShowMoveDialog(true)}
                    onUnassignVertical={
                      browseMode === "verticals" && selectedVerticalId
                        ? onUnassignVertical
                        : undefined
                    }
                  />
                ) : (
                  browseMode === "verticals" && contentStatus === "error" ? null : (
                    <Grid container spacing={{ xs: 2, md: 3, lg: 3 }}>
                      {skeletonItems.map((_, index) => (
                        <Grid item xs={12} sm={12} md={4} lg={4} key={index}>
                          <SkeletonThumbnailLoader />
                        </Grid>
                      ))}
                    </Grid>
                  )
                )}
              </>
            ) : browseMode === "verticals" && selectedVerticalName ? (
              <BoxComponent body={`No videos are available in ${selectedVerticalName}.`} />
            ) : (
              <BoxComponent body={locale.no_videos} />
            )}
          </div>
        </>
        {isShowFooter() && (
          <Footer marginLeft="345px" width="calc(100% - 419px)">
            <PageRecords
              records={totalRecords}
              pages={totalPages}
              selectedValue={selectedValue}
              onChangePageSize={onChangePageSize}
              defaultValue={DEFAULT_PAGE_SIZE}
            />
            <Pagination
              name={locale.goToPage}
              pages={totalPages}
              pageIndex={pageIndex}
              activePage={pageIndex}
              onChangePageRow={onChangePageRow}
              onChangePageIndex={onChangePageIndex}
              marginRight="2.5rem"
            />
          </Footer>
        )}
      </div>
      {(browseMode === "folders" || browseMode === "verticals") && isShowDeleteDialog && (
        <DialogBox
          header={locale.deleteHeader}
          body={<div>{locale.deleteBody}</div>}
          subBody={renderDeleteDialog()}
          onCancel={() => setIsShowDeleteDialog(false)}
          onSubmit={deleteVideos}
          isDelete
          primaryButton={locale.yes}
          secondaryButton={locale.no}
        />
      )}
      {(browseMode === "folders" || browseMode === "verticals") && isShowRetagDialog && (
        <DialogBox
          header={
            selectedThumbnails.length > 1
              ? locale.retag_header_multiple.replace(
                "%d",
                selectedThumbnails.length,
              )
              : locale.retag_header
          }
          body={<div>{locale.retag_description}</div>}
          subBody={renderRetagDialog()}
          onCancel={() => {
            setRetagValue("");
            setIsShowRetagDialog(false);
          }}
          onSubmit={onRetag}
          isDelete={false}
          primaryButton={locale.add}
          secondaryButton={locale.cancel}
        />
      )}
      {(browseMode === "folders" || browseMode === "verticals") && isShowMoveDialog && <MoveVideo />}

      {/* STAVC-327 bulk assignment; runtime capability remains authoritative. */}
      {isShowVerticalAssignmentDialog && selectedThumbnails.length > 0 && rolePermissions?.video?.retag === true && (
        <VideoAssignmentDialog
          open={isShowVerticalAssignmentDialog}
          videoIndexIds={selectedThumbnails.map((thumbnail: any) => thumbnail.videoIndexId)}
          selectedVideos={selectedThumbnails.map((thumbnail: any) => ({
            videoIndexId: thumbnail.videoIndexId,
            name: thumbnail.name,
            image: thumbnail.image,
          }))}
          taxonomy={{
            available: assignmentTaxonomyStatus === "loaded",
            verticals: assignmentTaxonomy,
          }}
          taxonomyStatus={
            assignmentTaxonomyStatus === "idle" ? "loading" : assignmentTaxonomyStatus
          }
          taxonomyError={assignmentTaxonomyError}
          readback={assignmentReadback}
          onClose={closeAssignmentDialog}
          onRetryTaxonomy={() => {
            void loadAssignmentTaxonomy();
          }}
          onRetryReadback={() => {
            if (selectedThumbnails.length === 1)
              void loadAssignmentReadback(selectedThumbnails[0].videoIndexId);
          }}
          onSubmit={onAssignmentSubmit}
          saving={assignmentSaving}
          dialogError={assignmentDialogError}
        />
      )}

      {(browseMode === "folders" || browseMode === "verticals") && isShowRenameDialog ? (
        <DialogBox
          header={locale.control_rename}
          body={<></>}
          subBody={
            <div>
              <TextFieldInput
                value={tempVideoTitle}
                onChange={(e: any) => setTempVideoTitle(e.target.value)}
              />
            </div>
          }
          onCancel={() => {
            setTempVideoTitle(selectedThumbnails[0]?.name || "");
            setIsShowRenameDialog(false);
          }}
          onSubmit={() => onSubmitRename()}
          isDelete={false}
          primaryButton={locale.save}
          secondaryButton={locale.cancel}
          disablePrimary={
            tempVideoTitle.trim() === "" ||
            tempVideoTitle === selectedThumbnails[0]?.name
          }
        ></DialogBox>
      ) : (
        <></>
      )}
    </>
  );
};

export default MainScreen;
